(function () {
  'use strict';

  function initReveals() {
    var elementos = document.querySelectorAll('.mt-reveal');
    if (!elementos.length) return;

    var mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mql.matches) {
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    elementos.forEach(function (el) { observer.observe(el); });
  }

  function initContadores() {
    var contadores = document.querySelectorAll('[data-mt-contador]');
    if (!contadores.length) return;

    var mql = window.matchMedia('(prefers-reduced-motion: reduce)');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var destino = parseFloat(el.dataset.mtContador || '0');
          var decimales = (el.dataset.mtContador.split('.')[1] || '').length;
          observer.unobserve(el);

          if (mql.matches) {
            el.textContent = destino.toFixed(decimales);
            return;
          }

          var inicio = null;
          var duracion = 1400;
          function paso(ts) {
            if (!inicio) inicio = ts;
            var avance = Math.min((ts - inicio) / duracion, 1);
            var facilitado = 1 - Math.pow(1 - avance, 3);
            el.textContent = (destino * facilitado).toFixed(decimales);
            if (avance < 1) requestAnimationFrame(paso);
          }
          requestAnimationFrame(paso);
        });
      },
      { threshold: 0.5 }
    );

    contadores.forEach(function (el) { observer.observe(el); });
  }

  function initMarquesinas() {
    var pistas = document.querySelectorAll('[data-mt-marquesina]');
    pistas.forEach(function (pista) {
      if (pista.dataset.mtDuplicado) return;
      pista.innerHTML += pista.innerHTML;
      pista.dataset.mtDuplicado = 'true';
    });
  }

  function initInclinacion() {
    var tarjetas = document.querySelectorAll('[data-mt-inclinar]');
    if (!tarjetas.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;

    tarjetas.forEach(function (tarjeta) {
      tarjeta.addEventListener('mousemove', function (e) {
        var r = tarjeta.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        tarjeta.style.transform = 'perspective(700px) rotateX(' + (y * -5) + 'deg) rotateY(' + (x * 5) + 'deg) translateY(-4px)';
      });
      tarjeta.addEventListener('mouseleave', function () {
        tarjeta.style.transform = '';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initContadores();
    initMarquesinas();
    initInclinacion();
  });
})();
